'use strict';

var App = require('app');
var Misc = require('utils/misc');
var OOP = require('utils/oop');

module.exports = OOP.extend(
    Marionette.Object,
    {
        selectionID: undefined,
        excluded: {},
        backgroundTasks: Misc.getBackgroundTaskManager(),

        initialize: function (options) {
            this.filter = options.filter;
            this.total = options.count;
            this.onUpdate = options.onUpdate;
            this.selectionID = options.selectionID;
            this.changeIdx = 1;
            this.excluded = {};
        },

        isEmpty: function () {
            var excludedCount = Misc.countWhere(this.excluded, function (item) {
                return item;
            });
            return excludedCount == this.total;
        },

        selectModels: function (models) {
            var self = this;
            _.each(models, function (m) {
                var wantSelected = !self.excluded[m.id];
                var isSelected = m.selected;
                if (Boolean(isSelected) != Boolean(wantSelected)) {
                    m.toggleSelected({ silent: true });
                }
            });
        },

        isBusy: function () {
            return this.backgroundTasks.isBusy();
        },

        done: function (fct) {
            this.backgroundTasks.done(fct);
        },

        saveChanges: function (changes) {
            var self = this;
            var req = App.requestSilent('devices:selection', {
                selection: this.selectionID,
                changes: changes,
                filter: this.filter,
            });
            this.backgroundTasks.when(req).done(function (selID) {
                _.each(changes, function (value, key) {
                    self.excluded[key] = !value;
                });

                self.selectionID = selID;

                // trigger onUpdate
                if (self.onUpdate) self.onUpdate();
            });
        },

        update: function (models, first) {
            this.changeIdx++;
            var self = this;
            var changes = {};

            _.each(models, function (m) {
                var wantSelected = m.selected;
                var isSelected = !self.excluded[m.id];
                if (wantSelected != isSelected) {
                    changes[m.id] = m.selected;
                }
            });

            if (this.isBusy()) {
                this.backgroundTasks.done(function () {
                    this.update(models);
                }, this);
            } else {
                if (_.keys(changes).length || first) {
                    this.saveChanges(changes);
                }
            }
        },
    },
    'DeviceSelection'
);
